export var Service;
(function (Service) {
    /**
     *  Keycloak Service
     */
    Service["KEYCLOAK"] = "keycloak";
    /**
     *  Customer Authentication Service
     */
    Service["CAS"] = "cas";
    /**
     *  User Management Service
     */
    Service["UMS"] = "ums";
    /**
     * Strong Customer Authentication Service
     */
    Service["SCAS"] = "scas";
    /**
     * Customer Postbox Service
     */
    Service["CPS"] = "cps";
    /**
     *  Integration Service
     */
    Service["IS"] = "is";
    /**
     *  Legacy Online Banking System
     */
    Service["OBS"] = "obs";
    /**
     *  Transaction Account Management Service
     */
    Service["TAMS"] = "tams";
    /**
     *  WJ Integration Service
     */
    Service["WJIS"] = "wjis";
    /**
     *  Customer Payment Method Service
     */
    Service["CPMS"] = "cpms";
    /**
     *  Zendesk
     */
    Service["Zendesk"] = "zendesk";
    /**
     * Document Depot Service
     */
    Service["DDS"] = "dds";
    /**
     *  Customer Taxation Service
     */
    Service["CTS"] = "cts";
    /**
     *  KYC Connector IDnow Service
     */
    Service["KCI"] = "kci";
    /**
     *  KYC Status Service
     */
    Service["KSS"] = "kss";
    /**
     *  KYC Connector Postident Service
     */
    Service["KCPS"] = "kcps";
    /**
     *  PSD Connector
     */
    Service["PSDC"] = "psdc";
    /**
     *  Customer Transaction Management API
     */
    Service["CTMS"] = "ctms";
    /**
     *  Pension service
     */
    Service["PENSION"] = "pension";
    /**
     *  Deposit Brokerage Service
     */
    Service["DBS"] = "dbs";
    /**
     *  Deposit Accounting Service
     */
    Service["DAS"] = "das";
    /**
     *  Deposit Document Service
     * @see https://dev.raisin.systems/catalog/default/api/deposit-document-apidefinition
     */
    Service["DDOC"] = "ddoc";
    /**
     *  Deposit Document Service
     * @see https://dev.raisin.systems/catalog/default/api/deposit-document-apidefinition
     */
    Service["DDOC_PUBLIC"] = "ddocpublic";
    /**
     *  Deposit Taxation Service
     * @see https://dev.raisin.systems/catalog/default/api/deposit-taxation-api
     */
    Service["DTS"] = "dts";
    /**
     *  Deposit Taxation Service Public
     * @see https://dev.raisin.systems/catalog/default/api/deposit-taxation-api
     */
    Service["DTS_PUBLIC"] = "dts_public";
})(Service || (Service = {}));
//# sourceMappingURL=service.js.map